import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import MesheryVersion from "../../../../src/collections/blog/2023/05-22-changing-release-channels-in-meshery/meshery-version.png";
import * as React from 'react';
export default {
  BlogWrapper,
  MesheryVersion,
  React
};